<!-- 单门店时（远程搜索） -->
<template>
    <el-select
        v-model="oneStoreID"
        :size="size"
        :filterable="filterable"
        :remote="remote"
        :clearable="clearable"
        :placeholder="placeholder"
        :remote-method="remoteMethod"
        :loading="getStoreLoading"
        :disabled="disabled"
        :value-key="valueType.valueKey"
        @change="onChange"
    >
        <el-option
            v-for="item in options"
            :key="item.id"
            :label="optionsLable(item)"
            :value="valueType.type === 'object'?item:item.id" >
        </el-option>
    </el-select>
</template>

<script>
import { getStores } from "@/apis/controls/shop.js";
export default {
    name: 'jxSelectPick',
    props: {
        value: {
            // type: [String,Array]
            // type: Number
        },
        filterable: {
            type: Boolean,
            default: true
        },
        remote: {
            type: Boolean,
            default: true
        },
        clearable: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: "请输入门店关键字"
        },
        size: {
            type:String,
            default:"small"
        },
        disabled: {
            type: Boolean,
            defult:false
        },
        vendorID: {
            type: [String,Array]
        },
        valueType: {
            type: Object,
            default: () => {
                return {
                    type:'',
                    valueKey: '',
                    label:['id','name']
                }
            }
        },
        vendorOrgCode: {
            type: String,
            default:''
        }
    },
    data() {
        return {
            getStoreLoading: false,
            options: [],
            oneStoreID: null,
            searchParams: {
                keyword:'', 
                pageSize:10
            }
        }
    },
    created() {
        // console.log('valueType',this.valueType)
    },
    watch: {
        value: {
            handler(val) {
                if(val) this.oneStoreID = val
            }
        },
        oneStoreID: {
            handler(val) {
                this.$emit("input", val)
            }
        },
        vendorID: {
            handler(val) {
                if (val && val.length > 0) {
                    this.searchParams['vendorStoreCond'] = 'and'
                    let vendorStoreConds = {
                        0: '0', // 京东不限定
                        1: '0', // 美团不限定
                        2: '0', // e了么不限定
                        3: '0', // 饿百
                        4: '0',
                        5: '0',
                        9: '0', // 京西
                        11: '0',
                        14: '0', // 抖店
                        16: '0' // 淘鲜达
                    }
                    if (!Array.isArray(val)) {
                        vendorStoreConds[val] = '1'
                    } else {
                        val.forEach(element => {
                            vendorStoreConds[element] = '1'
                        })
                    }
                    this.searchParams['vendorStoreConds'] = JSON.stringify(vendorStoreConds)
                    this.oneStoreID = null
                }
                
            },
            immediate:true
        },
        vendorOrgCode: {
            handler(val) {
                if (val && this.options.length > 0) {
                    this.options = this.options.filter(item => (item.StoreMaps.filter(i => i.vendorOrgCode === val)).length)
                    this.oneStoreID = null
                }
            },
            immediate:true
        }
    },
    methods: {
        // 选中的值发生改变时
        onChange(e) {
            this.$emit("input", e)
            this.$emit('change',e)
        },
        // label内容显示
        optionsLable(item) {
            let label = ''
            if (this.valueType.label && this.valueType.label.length>0) {
                this.valueType.label.forEach(i => {
                    if(i!== this.valueType.label[this.valueType.label.length-1]) label =label + item[i] + ' - '
                    else label = label + item[i]
                })
            }else label = item.id + ' - ' + item.name
            return label
        },
        // 远程查找门店
        async remoteMethod(storeKeyWord) {
            this.getStoreLoading = true;
            this.searchParams.keyword = storeKeyWord
            try {
                let { stores } = await getStores(this.searchParams,true)
                stores = stores || [];
                if (this.vendorOrgCode && stores.length) stores = stores.filter(item => (item.StoreMaps.filter(i => i.vendorOrgCode === this.vendorOrgCode)).length)
                this.options = stores;
            } catch (e) {
                this.$message({
                    message: "远程查找门店失败",
                    type: "warning",
                    center: true,
                });
            } finally {
                this.getStoreLoading = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss'
</style>


// WEBPACK FOOTER //
// src/components/cmp/selectPick/index.vue